import styled from 'styled-components';

const LabelContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding-bottom: ${props => !props.noPadding && '8px'};
  width: ${props => props.width && props.width};
`;

export default LabelContainer;
